export const PRODUCTVARIAN_LOADING = "PRODUCTVARIAN_LOADING";
export const PRODUCTVARIAN_RESET = "PRODUCTVARIAN_RESET";
export const GET_PRODUCTVARIAN = "GET_PRODUCTVARIAN";
export const GET_PRODUCTVARIAN_SUCCESS = "GET_PRODUCTVARIAN_SUCCESS";
export const GET_PRODUCTVARIAN_FAIL = "GET_PRODUCTVARIAN_FAIL";
export const DELETE_PRODUCTVARIAN = "DELETE_PRODUCTVARIAN"
export const DELETE_PRODUCTVARIAN_SUCCESS = "DELETE_PRODUCTVARIAN_SUCCESS"
export const DELETE_PRODUCTVARIAN_FAIL = "DELETE_PRODUCTVARIAN_FAIL"
export const UPDATE_PRODUCTVARIAN = "UPDATE_PRODUCTVARIAN"
export const UPDATE_PRODUCTVARIAN_SUCCESS = "UPDATE_PRODUCTVARIAN_SUCCESS"
export const UPDATE_PRODUCTVARIAN_FAIL = "UPDATE_PRODUCTVARIAN_FAIL"
export const ADD_NEW_PRODUCTVARIAN = "ADD_NEW_PRODUCTVARIAN"
export const ADD_PRODUCTVARIAN_SUCCESS = "ADD_PRODUCTVARIAN_SUCCESS"
export const ADD_PRODUCTVARIAN_FAIL = "ADD_PRODUCTVARIAN_FAIL"